export default __webpack_public_path__ + "static/media/5071.34bbb037.png";